import { SemigroupAll, SemigroupAny } from "fp-ts/boolean";
import { curry2 } from "./Function";
export const invert = x => !x;
export const and = curry2(SemigroupAll.concat);
export const or = curry2(SemigroupAny.concat);
export const xor = (x) => y => (x && !y) || (!x && y);
